import Route from '@ember/routing/route';
import { instrumentRoutePerformance } from '@sentry/ember';

class SettingsGroupsGroupEditRoute extends Route {
  model() {
    return this.modelFor('settings.groups.group');
  }
}

export default instrumentRoutePerformance(SettingsGroupsGroupEditRoute);
